import { SurveyModule } from './../survey/survey.module'
import { ActivityModule } from './../activity/activity.module'
import { CalendarService } from './../../shared/components/calendar/calendar.service'
import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromBooking from '../booking/booking.reducer'
import { BookingRoutingModule } from './booking-routing.module'
import { BookingEffects } from './booking.effects'
import { BookingSerializer } from './booking.serializer'
import { BookingService } from './booking.service'

import { LocationModule } from '../location/location.module'
import { BookingOverviewComponent } from './overview/show.component'
import { ProductModule } from '../product/product.module'
import { BookingCreateComponent } from './create/create.component'
import { BookingIndexComponent } from './index/index.component'
import { BookingFormComponent } from './form-general/form-general.component'
import { BookingShowComponent } from './show/show.component'
import { ParticipationModule } from './participation/participation.module'
import { BookingParticipationTabComponent } from './participation-tab/show.component'
import { BookingTableComponent } from './booking-table/table.component'
import { MemberModule } from '../member/member.module'
import { BookingShowModalComponent } from './show-modal/show.component'
import { BookingRepeatTabComponent } from './repeat-tab/show.component'
import { BookingFormRepeatComponent } from './form-repeat/form-repeat.component'
import { BookingMultiCreateFormComponent } from './multi-create-form/form.component'
import { SaleModule } from '../sale/sale.module'
import { BookingSaleTabComponent } from './sale-tab/show.component'
import { BookingAllowedLinkedProductTabComponent } from './allowed-product-tab/show.component'
import { BookingAllowedLinkedProductService } from './booking-allowed-linked-product.service'
import { BookingRelationEffects } from './booking-relation.effects'
import { BookingFormDetailsComponent } from './form-general-details/form-general.component'
import { BookingGeneralTabComponent } from './general-tab/show.component'
import { BookingDetailsTabComponent } from './details-tab/show.component'
import { BookingSupervisorTabComponent } from './supervisor-tab/show.component'
import { BookingSupervisorBookingService } from './booking-supervisor-booking.service'
import { RoleModule } from '../role/role.module'
import { SupervisorBookingModule } from '../supervisor-booking/supervisor-booking.module'
import { BookingSelectInput } from './booking-select-input/show.component'
import { BookingDocumentService } from './booking-document.service'
import { BookingDocumentsTabComponent } from './documents-tab/show.component'
import { DocumentModule } from '../document/document.module'
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker'
import { BookingItemModule } from './booking-item/booking-item.module'
import { OverviewScheduleComponent } from './overview-schedule/show.component'
import { BookingCommunicationTabComponent } from './communication-tab/show.component'
import { EmailTaskModule } from '../email-task/email-task.module'
import { ChangeDateModalComponent } from './booking-item/change-date-modal/change-date-modal.component'
import { SupervisorBookingContractSelectionModal } from './supervisor-tab/confirm-employee-booking-creation-modal/show.component'
import { SupervisorSerieIdChangeConfirmModalComponent } from './supervisor-tab/supervisor-serie-id-change-confirm-modal/supervisor-serie-id-change-confirm-modal.component'
import { ModalTableUnavailableActionComponent } from './supervisor-tab/modal-table-unavailable-action/modal-table-unavailable-action.component'
import { BookingSeriesModalComponent } from './booking-series-modal/booking-series-modal..component'
import { ProcessingnModalComponent } from './supervisor-tab/processing-modal/processing-modal.component'
import { OperationTabComponent } from './operation-tab/operation-tab.component'
import { AddParticipationsModalComponent } from './show-modal/add-participations-modal/add-participations-modal.component'
import { BookingSerieTabComponent } from './booking-serie-tab/show.component'
import { BookingSupervisorAssignComponent } from './supervisor-assign/show.component'
import { CreateRepeatFormFromBookingPipe } from './repeat-tab/create-repeat-form-from-booking.pipe'
import { CreateSelectedFormFromBookingPipe } from './repeat-tab/create-selecteted-form-from-booking.pipe'
import { BookingReviewTableComponent } from './booking-review-table/table.component'
import { SerieProposalIndexComponent } from './serie-proposal/index/index.component'
import { SerieProposalShowComponent } from './serie-proposal/show/show.component'
import { SerieProposalFormGeneralComponent } from './serie-proposal/form-general/form.component'
import { SerieProposalGeneralTabComponent } from './serie-proposal/general-tab/show.component'
import { SerieProposalTableComponent } from './serie-proposal/table/table.component'
import { SerieProposalSeriesTabComponent } from './serie-proposal/series-tab/show.component'
import { SerieProposalMessagesTabComponent } from './serie-proposal/messages-tab/messages-tab.component'
import { ConfirmationModalComponent } from './serie-proposal/series-tab/confirmation-modal/confirmation-modal.component'
import { SerieProposalSalesTabComponent } from './serie-proposal/sales-tab/show.component'
import { SerieProposalModule } from './serie-proposal/serie-proposal.module'
import { DataTableModule } from '@pascalhonegger/ng-datatable'
import { SerieProposalItemScheduleCellComponent } from './serie-proposal/serie-proposal-item/overview-schedule/schedule/schedule-cell.component'
import { SerieProposalItemScheduleComponent } from './serie-proposal/serie-proposal-item/overview-schedule/schedule/show.component'
import { SerieProposalItemOverviewScheduleComponent } from './serie-proposal/serie-proposal-item/overview-schedule/show.component'
import { SerieProposalItemTableComponent } from './serie-proposal/serie-proposal-item/table/table.component'
import { SerieProposalItemEditModal } from './serie-proposal/serie-proposal-item/serie-proposal-item-create-edit-modal/show.component'
import { SerieProposalShowModalComponent } from './serie-proposal/show-modal/show.component'
import { SerieProposalOverviewScheduleComponent } from './serie-proposal/overview-schedule/show.component'
import { SerieProposalScheduleComponent } from './serie-proposal/schedule/show.component'
import { SerieProposalEditModalComponent } from './serie-proposal/serie-proposal-edit-modal/show.component'
import { SerieProposalSeriesModalComponent } from './serie-proposal/serie-proposal-series-modal/serie-proposal-series-modal.component'
import { GetProposalsForProductPipe } from './serie-proposal/schedule/get-proposals-for-product.pipe'
import { SerieProposalInitialRequestModalComponent } from './serie-proposal/initial-request-modal/initial-request-modal.component'
import { SerieProposalInitialRequestGeneralTabComponent } from './serie-proposal/initial-request-general-tab/show.component'
import { SerieProposalItemShowModalComponent } from './serie-proposal/serie-proposal-series-item-modal/show-modal.component'
import { CommunicationBlockModule } from 'src/app/shared/components/communication-block/communication-block.module'
import { activitiesBlockModule } from 'src/app/shared/components/activities-block/activities-block.module'
import { LogsTabComponent } from './logs-tab/logs-tab.component'
import { AddCategoryParticipationsModalComponent } from './show-modal/add-category-participations-modal/add-category-participations-modal.component'
import { DeleteBookingsModalComponent } from './delete-bookings-modal/delete-bookings-modal.component'
import { BulkParticipantConflictsModalComponent } from './bulk-participant-conflicts-modal/bulk-participant-conflicts-modal.component'
import { BulkParticipantResultModalComponent } from './bulk-participant-result-modal/bulk-participant-result-modal.component'

@NgModule({
  imports: [
    BookingRoutingModule, // must be before other modules with routes
    SharedModule,
    StoreModule.forFeature(
      fromBooking.FEATURE_NAME,
      fromBooking.bookingReducer
    ),
    EffectsModule.forFeature([BookingEffects, BookingRelationEffects]),
    BookingItemModule,
    LocationModule,
    ProductModule,
    ParticipationModule,
    MemberModule,
    SaleModule,
    RoleModule,
    SupervisorBookingModule,
    DocumentModule,
    NzDatePickerModule,
    EmailTaskModule,
    ActivityModule,
    SurveyModule,
    SerieProposalModule,
    DataTableModule,
    CommunicationBlockModule,
    activitiesBlockModule
  ],
  declarations: [
    GetProposalsForProductPipe,
    CreateSelectedFormFromBookingPipe,
    CreateRepeatFormFromBookingPipe,
    BookingSupervisorAssignComponent,
    ProcessingnModalComponent,
    BookingSerieTabComponent,
    ChangeDateModalComponent,
    BookingSeriesModalComponent,
    BookingIndexComponent,
    BookingFormComponent,
    BookingFormRepeatComponent,
    BookingRepeatTabComponent,
    BookingTableComponent,
    BookingShowComponent,
    BookingCreateComponent,
    BookingGeneralTabComponent,
    BookingParticipationTabComponent,
    BookingOverviewComponent,
    BookingShowModalComponent,
    BookingMultiCreateFormComponent,
    BookingSaleTabComponent,
    BookingAllowedLinkedProductTabComponent,
    BookingDetailsTabComponent,
    BookingCommunicationTabComponent,
    BookingFormDetailsComponent,
    BookingSupervisorTabComponent,
    OperationTabComponent,
    BookingSelectInput,
    BookingDocumentsTabComponent,
    OverviewScheduleComponent,
    SupervisorBookingContractSelectionModal,
    SupervisorSerieIdChangeConfirmModalComponent,
    ModalTableUnavailableActionComponent,
    AddParticipationsModalComponent,
    BookingReviewTableComponent,
    SerieProposalIndexComponent,
    SerieProposalShowComponent,
    SerieProposalFormGeneralComponent,
    SerieProposalGeneralTabComponent,
    SerieProposalTableComponent,
    SerieProposalSeriesTabComponent,
    SerieProposalMessagesTabComponent,
    ConfirmationModalComponent,
    SerieProposalSalesTabComponent,
    SerieProposalItemTableComponent,
    SerieProposalItemEditModal,
    SerieProposalItemOverviewScheduleComponent,
    SerieProposalItemScheduleComponent,
    SerieProposalItemScheduleCellComponent,
    SerieProposalShowModalComponent,
    SerieProposalOverviewScheduleComponent,
    SerieProposalScheduleComponent,
    SerieProposalEditModalComponent,
    SerieProposalItemShowModalComponent,
    SerieProposalSeriesModalComponent,
    SerieProposalInitialRequestModalComponent,
    SerieProposalInitialRequestGeneralTabComponent,
    LogsTabComponent,
    AddCategoryParticipationsModalComponent,
    DeleteBookingsModalComponent,
    BulkParticipantConflictsModalComponent,
    BulkParticipantResultModalComponent
  ],
  exports: [
    ProductModule,
    BookingTableComponent,
    BookingFormDetailsComponent,
    BookingSelectInput,
    BookingShowModalComponent,
    OverviewScheduleComponent,
    BookingCreateComponent
  ],
  providers: [
    BookingService,
    BookingAllowedLinkedProductService,
    BookingSupervisorBookingService,
    BookingDocumentService,
    CalendarService,
    {
      provide: BookingSerializer,
      useClass: BookingSerializer
    }
  ]
})
export class BookingModule {}
